import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

import { Size } from '../../types';
import { colors, sizes } from '../../styles';

export interface Props {
  className?: string;
  state?: string;
  size?: Size;
}

class StateIcon extends React.Component<Props, {}> {
  public static defaultProps: Props = {
    state: 'none',
    size: 'md',
  };

  public render() {
    const { className, size } = this.props;

    return <div className={`${className} ${size}`} />;
  }
}

export default styled(StateIcon)`
  ${sizes.createRules(sizes.state)};
  background-color: ${props => colors[props.state]};
  border-radius: 100%;
`;
